import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Button } from './chroma';

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  & > div {
    width: 100%;
  }
  & > :first-child {
    padding-right: 4px;
  }

  & > :last-child {
    padding-left: 4px;
  }
`;

export interface YesNoButtonGroupProps {
  onYes: Function;
  onNo: Function;
}

export const YesNoButtonGroup: FunctionComponent<YesNoButtonGroupProps> = ({
  onYes,
  onNo,
}) => (
  <ButtonWrapper>
    <Button primary size="lg" type="submit" maxWidth onClick={onYes}>
      Yes
    </Button>
    <Button primary size="lg" type="submit" maxWidth onClick={onNo}>
      No
    </Button>
  </ButtonWrapper>
);

export default YesNoButtonGroup;
